export const LOW_DETRACTOR_SEGMENT_ID = 1
export const HIGH_DETRACTOR_SEGMENT_ID = 3

export enum BuyButtonPosition {
  ConversationMessageOfferRequest = 'conversation_message_offer_request',
  ConversationMessageOffer = 'conversation_message_offer',
  ConversationHeader = 'conversation_header',
}
